import React from 'react';
import { Tooltip } from '@mui/material';
import clsx from 'clsx';
import {
    ExternalIconNames,
    IconNames,
} from '@innersource-nn/novoui-react/dist/external-lib/NIcon/icons';
import DropdownMenu from './DropdownMenu';
import { NButton } from '@innersource-nn/novoui-react';

export interface ButtonConfig {
    tooltip?: string;
    loading?: boolean;
    red?: boolean;
    onClick: () => void;
    icon?: IconNames | ExternalIconNames | undefined;
    disabled?: boolean;
    label: string;
}

interface HeaderProps {
    title: string;
    buttonConfigs?: ButtonConfig[];
}

const Header: React.FC<HeaderProps> = ({ title, buttonConfigs }) => {
    const moreThanTwoButtons = buttonConfigs && buttonConfigs.length > 2;
    return (
        <div className="grid grid-cols-10 my-8">
            <h1
                className={clsx(
                    moreThanTwoButtons ? '3xl:col-span-5' : 'xl:col-span-7',
                    'text-true-blue text-h-140-bold break-all col-span-9 ',
                )}
            >
                {title}
            </h1>
            {/* Show buttons for medium and larger screens */}
            <div
                className={clsx(
                    moreThanTwoButtons
                        ? '3xl:flex 3xl:col-span-5'
                        : 'xl:flex xl:col-span-3',
                    'hidden justify-end gap-8 ',
                )}
            >
                {buttonConfigs &&
                    buttonConfigs.map((button, index) => (
                        <div key={index}>
                            <Tooltip
                                title={button.tooltip}
                                key={`${index}-tooltip`}
                                arrow
                            >
                                <div>
                                    <NButton
                                        className={clsx(
                                            button.red && 'outline-red-button',
                                            'w-full',
                                        )}
                                        key={`${index}-button`}
                                        square
                                        variant={
                                            button.red && !button.disabled
                                                ? undefined
                                                : 'outline'
                                        }
                                        disabled={button.disabled}
                                        leftIcon={button.icon}
                                        isLoading={button.loading}
                                        onClick={button.onClick}
                                    >
                                        {button.label}
                                    </NButton>
                                </div>
                            </Tooltip>
                        </div>
                    ))}
            </div>
            {/* Show dropdown menu for small screens */}
            {!!buttonConfigs?.length && (
                <div
                    className={clsx(
                        moreThanTwoButtons ? '3xl:hidden' : 'xl:hidden',
                        'flex justify-end col-span-1',
                    )}
                >
                    <DropdownMenu buttonConfigs={buttonConfigs} />
                </div>
            )}
        </div>
    );
};

export default Header;
